

















import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { ParsedEVMTx } from '@/store/modules/transactions/helpers/parseEVMTxs'

@Component({
    components: {},
})
export default class Transactions extends Vue {
    get latestTransaction(): ParsedEVMTx | null {
        return this.$store.state.Transactions.evmTx
    }

    shortenText(source: string, index: number) {
        if (index >= source.length) return source

        return `${source.substring(0, index)}...${source.substring(
            source.length - index,
            source.length
        )}`
    }

    mounted() {
        this.$store.dispatch('Transactions/getEVMTx', {
            limit: 1,
            sort: 'timestamp-desc',
        })
    }
}
